import { Stack, Typography } from "@mui/material";
import EntriliaLabelIcon from "@entrilia/shared/icons/EntriliaLabelIcon";

const ReportProductName = ({ title }: { title: string }) => {
  return (
    <Stack spacing={"3px"}>
      <EntriliaLabelIcon sx={(t) => ({ width: 72, height: 19, color: t.palette.text.primary })} />
      <Typography color="textSecondary" sx={{ fontSize: 10, fontWeight: 400, letterSpacing: 0.1, lineHeight: "100%" }}>
        {title}
      </Typography>
    </Stack>
  );
};

export default ReportProductName;
